export { default } from "./isFocusVisible.mjs";